import Link from '@Components/common/Link';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const List = styled.div`
  background-color: ${({ theme }) => theme.colors.filterCardBg};
  width: 100%;
  padding-bottom: 50px;
  border-radius: 4px;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 40px;
  ${mq(1200)} {
    margin-bottom: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 30px;
  background-color: ${({ theme }) => theme.colors.cartBg};
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  margin-bottom: 16px;
  ${mq(576)} {
    flex-direction: column;
    padding: 14px;
    align-items: flex-start;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  p {
    font-size: ${({ theme }) => theme.fontsizes.body18};
    color: ${({ theme }) => theme.colors.black2};
    font-weight: ${({ theme }) => theme.fontWeight.font700};
    margin-right: 6px;
  }
`;

export const Amount = styled.span`
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.lightPurple};
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  ${mq(576)} {
    width: 100%;
  }
`;

export const Price = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body18};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  margin-right: 58px;
`;

export const CheckoutBtn = styled(Link)`
  padding: 0 20px;
  cursor: pointer;
  line-height: 48px;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.brandColor};
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  ${mq(576)} {
    margin-left: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  ${mq(576)} {
    padding: 0 14px;
  }
`;
